import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const awsContractsResponseSchema = z.object({
    contracts: z.array(z.object({
        id: z.number(),
        listingName: z.string(),
        customerAWSAccountId: z.string(),
        privateOfferName: z.string().nullish(),
        privateOfferId: z.string().nullish(),
    })),
});
export class AwsContractsResponseDto extends createZodDto(awsContractsResponseSchema) {
}
